<div class="annotation-list">
  <rdrx-annotation-list-header
    [headerClass]="(emptyTree$ | async) || (sessionEnded$ | async)"
    [type]="headerType"
    [isEditMode]="isEditMode"
    [areAllAnnotationsSelected]="allAnnotationsSelected"
    (dropdownOptionSelected)="handleDropdownState($event)"
    (editModeSelected)="handleEditMode($event)"
    (allAnnotationsSelected)="handleAllAnnotationsSelected($event)"
    (exportAnnotationsSelected)="beginExport()"
  ></rdrx-annotation-list-header>

  <div class="content">

    @if (emptyTree$ | async) {
      <p class="list-empty-msg" translate>contents.highlight_blank</p>
    }
    @if (sessionEnded$ | async) {
      <mhe-alert data-automation-id="highlight-list-session-error-alert" [smallAlert]="true" [type]="AlertType.Warning" [closable]="false">
        {{ 'contents.highlight_session_error' | translate }}
      </mhe-alert>
    }
    @if (exportStatus$ | async) {
      <div class="export-alert">
        <mhe-alert data-automation-id="highlight-list-export-alert" [smallAlert]="true" [type]="AlertType.Info" [closable]="true">
          {{ 'export.in_progress' | translate }}
        </mhe-alert>
      </div>
    }

    <ngx-bonsai
      class="rdrx"
      rdrxBonsaiTabIndex data-automation-id="highlights-group"
      [nodesById]="nodeTree$ | async | orphanAnnotationsFilter:highlightDropDownState()"
      [rootNodeId]="rootNodeId"
      [expandedNodes]="higlightListStore.expandedNodes$ | async"
      [showToggleFn]="isCollapsible"
      [isLoading]="isLoading"
      (expanderClick)="toggleNodeExpanded($event)"
      >
      <ng-template #treeNodeTemplate let-node>
        <div
          mheStopPropagation
          rdrxBonsaiNodeSelect
          class="annotation-item highlight"
          data-automation-id="highlights-children"
          [rdrxBonsaiNodeSelectKeyboard]="!node.collapsible"
          (click)="handleNodeClick(node)"
          >
          @if (isEditMode && !node.collapsible) {
            <mhe-checkbox
              data-automation-id="highlight-annotation-checkbox"
              id="check-annotation"
              [checked]="isNodeChecked(node)"
              (change)="handleCheckAnnotation(node)"
            >&nbsp;</mhe-checkbox>
          }
          @if (node.annotation) {
            <div
              [ngClass]="{'image': !isEditMode }"
              >
              @if (node.annotation.orphan) {
                <div>
                  <img
                    id='unlink-icon' data-automation-id='unlink-icon'
                    src="/assets/icons/reader/unlink.svg"
                    alt="Unlink Icon"
                    width="30px"
                    [mheTooltip]="'context.detached_highlight' | translate"
                    [placement]="'right'">
                </div>
              } @else {
                <rdrx-highlight-icon [color]="node.annotation?.color" [shape]="node.annotation?.shape"></rdrx-highlight-icon>
              }
            </div>
          }

          <div class="title">
            @if (node.annotation?.orphan) {
              <p
                class="orphan-highlight-msg"
                >
                {{ 'contents.orphan_highlight_msg' | translate }}
              </p>
            }
            @if (node.annotation?.updatedAt) {
              <span class="date">
                {{ node.annotation?.updatedAt | date : 'shortDate' }}
              </span>
            }
            <span id="expandable-highlight-{{ node.id }}" (text)="handleTextChange($event, node)" rdrxTruncate>
              {{ node.title }}
            </span>
          </div>
          @if (!node.collapsible) {
            <button
              class="trashcan"
              mhe-button
              [attr.data-automation-id]="'remove-annotation-' + node.id"
              [disabled]="higlightListStore.readonly$ | async"
              [purpose]="ButtonPurpose.Icon"
              [mheStopPropagation]="['click', 'keydown.Enter', 'keydown.Space']"
              rdrxHideOnEscape
              [mheTooltip]="'context.remove_highlight' | translate"
              [alternateAriaLabel]="('context.remove_highlight' | translate) + ' ' + node.ariaLabel"
              (click)="delete(node.annotation)">
              <i class="dpg-icon dpg-icon-trash"></i>
            </button>
          }
        </div>
      </ng-template>
      <ng-template #loadingTemplate>
        <mat-progress-spinner
          data-automation-id="highlight-list-spinner"
          class="rdrx-spinner spine-annotations-loading"
          mode="indeterminate"
          [strokeWidth]="2"
          [diameter]="75"
        ></mat-progress-spinner>
      </ng-template>
    </ngx-bonsai>
  </div>
  @if (isEditMode) {
    <rdrx-annotation-list-footer
      class="rdrx-annotation-list-footer"
      [disableDeleteBtn]="!isFooterBtnDisabled"
      (deleteClick)="handleDeleteClick()"
      (cancelClick)="handleCancelClick()"
    ></rdrx-annotation-list-footer>
  }
</div>
